/* eslint-disable no-dupe-keys */
// https://github.com/codesandbox/codesandbox-client/tree/ce4d1a0bb049c592ce2e9b5011b290899f856acd/packages/common/src/themes
module.exports = {
  base: 'vs-dark',
  type: 'dark',
  inherit: true,
  rules: [],
  colors: {
    'activityBar.background': '#151515',
    'activityBar.border': '#242424',
    'button.background': '#0971F1',
    'button.foreground': '#fff',
    'button.border': '#0971F1',
    'button.hoverBackground': '#0971F1',

    'dropdown.background': '#151515',
    'dropdown.border': '#242424',
    'dropdown.foreground': '#fff',
    'terminal.background': '#040404',
    'terminal.foreground': '#fff',
    'terminal.ansiBrightBlack': '#535BCF',
    'terminal.ansiBrightRed': '#E1270E',
    'terminal.ansiBrightGreen': '#5BC266',
    'terminal.ansiBrightYellow': '#FBCC43',
    'terminal.ansiBlack': '#21222C',
    'terminal.ansiRed': '#E1270E',
    'terminal.ansiGreen': '#5BC266',
    'terminal.ansiYellow': '#FBCC43',
    'terminal.ansiBlue': '#535BCF',
    'terminal.ansiMagenta': '#BF5AF2',
    'terminal.ansiCyan': '#6CC7F6',
    'terminal.ansiWhite': '#fff',

    contrastBorder: '#242424',

    'selection.background': '#535BCF',
    errorForeground: '#E1270E',
    'input.background': '#242424',
    'input.foreground': '#fff',
    'input.border': '#040404',

    'input.placeholderForeground': '#999',
    'inputOption.activeBorder': '#6CC7F6',
    'inputValidation.infoBorder': '#BF5AF2',
    'inputValidation.warningBorder': '#FBCC43',
    'inputValidation.errorBorder': '#E1270E',
    'tab.activeBackground': '#282A36',
    'tab.activeForeground': '#F8F8F2',
    'editor.background': '#151515',
    'editor.foreground': '#ffffff',
    'editor.hoverHighlightBackground': '#333',
    'editor.inactiveSelectionBackground': '#333',

    'editorLineNumber.foreground': '#242424',
    'editorGroup.background': '#151515',
    'editorGroup.border': '#242424',
    'editorGroup.dropBackground': '#151515',
    'editorGroupHeader.tabsBackground': '#151515',

    'editor.lineHighlightBackground': '#242424',
    'editor.lineHighlightBorder': '#242424',
    'editor.rangeHighlightBackground': '#222',

    'editor.selectionBackground': '#242424',

    'editor.selectionHighlightBackground': '#242424',

    'editor.wordHighlightStrongBackground': '#242424',

    'editor.wordHighlightBackground': '#242424',
    'editorBracketMatch.background': '#242424',
    'editorBracketMatch.border': '#242424',
    'editorCodeLens.foreground': '#242424',
    'editorCursor.background': '#151515',
    'editorCursor.foreground': '#fff',
    'editorError.border': '#242424',
    'editorError.foreground': '#E1270E',

    'editorGutter.background': '#151515',
    'editorGutter.deletedBackground': '#E1270E',
    'editorGutter.modifiedBackground': '#151515',

    'editorGroup.background': '#151515',
    'editorGroup.border': '#242424',
    'editorGroup.dropBackground': '#151515',

    'editorGroupHeader.tabsBackground': '#151515',
    'editorGroupHeader.tabsBorder': '#242424',

    'editorHoverWidget.background': '#151515',
    'editorHoverWidget.border': '#242424',
    'editorIndentGuide.background': '#151515',
    'editorLineNumber.foreground': '#242424',
    'editorLineNumber.activeForeground': '#757575',
    'editorLink.activeForeground': '#999',

    'editorMarkerNavigation.background': '#151515',
    'editorMarkerNavigationError.background': '#151515',
    'editorMarkerNavigationWarning.background': '#242424',

    'editorOverviewRuler.border': '#242424',
    'editorOverviewRuler.commonContentForeground': '#242424',
    'editorOverviewRuler.currentContentForeground': '#E1270E',
    'editorOverviewRuler.incomingContentForeground': '#5BC266',
    'editorRuler.foreground': '#fff',

    'editorSuggestWidget.background': '#151515',
    'editorSuggestWidget.border': '#242424',
    'editorSuggestWidget.foreground': '#999',
    'editorSuggestWidget.selectedBackground': '#242424',

    'editorWarning.border': '#242424',
    'editorWarning.foreground': '#F35644',
    'editorWhitespace.foreground': '#444',
    'editorWidget.background': '#111',
    'editorWidget.border': '#2d2d2d',
    errorForeground: '#e27e8d',

    'extensionButton.prominentBackground': '#242424',
    'extensionButton.prominentForeground': '#fff',
    'extensionButton.prominentHoverBackground': '#242424',
    focusBorder: '#242424',
    foreground: '#999',
    'peekView.border': '#353535',
    'peekViewEditor.background': '#242424',
    'peekViewEditor.matchHighlightBackground': '#76D0FB',
    'peekViewResult.background': '#242424',
    'peekViewResult.fileForeground': '#fff',
    'peekViewResult.lineForeground': '#fff',
    'peekViewResult.matchHighlightBackground': '#76D0FB',
    'peekViewResult.selectionBackground': '#242424',
    'peekViewResult.selectionForeground': '#fff',
    'peekViewTitle.background': '#242424',
    'peekViewTitleDescription.foreground': '#535BCF',
    'peekViewTitleLabel.foreground': '#fff',

    'tab.activeBackground': '#151515',
    'tab.activeForeground': '#fff',
    'tab.border': '#242424',
    'tab.activeBorder': '#6CC7F6',
    'tab.inactiveBackground': '#151515',
    'tab.inactiveForeground': '#757575',
    'tab.unfocusedActiveForeground': '#ffffff',
    'tab.unfocusedInactiveForeground': '#757575',
    'activityBarBadge.background': '#E1270E',
    'sideBarTitle.foreground': '#ffffff',

    'scrollbarSlider.activeBackground': '#fff',
    'scrollbarSlider.border': '#242424',
    'sideBar.background': '#151515',
    'sideBar.border': '#242424',
    'sideBar.foreground': '#ffffff',
    'sideBarSectionHeader.background': '#151515',
    'sideBarSectionHeader.foreground': '#ffffff',
    'sideBarSectionHeader.border': '#242424',
    'sideBar.hoverBackground': '#00ff00',

    'statusBar.background': '#242424',
    'statusBar.foreground': '#ffffff',
    'statusBar.debuggingBackground': '#E1270E',
    'statusBar.debuggingForeground': '#242424',
    'statusBar.noFolderBackground': '#242424',
    'statusBar.noFolderForeground': '#F8F8F2',
    'statusBarItem.prominentBackground': '#E1270E',
    'statusBarItem.prominentBackground': '#E1270E',
    'statusBarItem.prominentHoverBackground': '#FFB86C',
    'statusBarItem.remoteForeground': '#e6e6e6',
    'statusBarItem.remoteBackground': '#BF5AF2',
    'statusBar.border': '#242424',
    'titleBar.background': '#151515',
    'titleBar.activeBackground': '#151515',
    'titleBar.activeForeground': '#fff',
    'titleBar.border': '#242424',
    'titleBar.inactiveBackground': '#151515',
    'titleBar.inactiveForeground': '#999',

    'menu.background': '#151515',
    'menu.selectionBackground': '#242424',
    'list.activeSelectionBackground': '#151515',
    'list.activeSelectionForeground': '#fff',
    'list.dropBackground': '#151515',
    'list.focusBackground': '#151515',
    'list.highlightForeground': '#6CC7F6',
    'list.hoverBackground': '#242424',
    'list.warningForeground': '#FBCC43',
    'list.errorForeground': '#E1270E',
  },
};
